<template>
  <div>
    <div
      v-if="!items.length"
      class="text-caption grey--text"
    >
      {{ emptyLabel }}
    </div>
    <v-simple-table
      v-else
      dense
      class="breakdown-table"
    >
      <tbody>
        <tr
          v-for="row in items"
          :key="row.name"
        >
          <td class="breakdown-name text-caption">
            {{ row.name }}
          </td>
          <td class="text-right text-caption font-weight-bold">
            {{ row.call_count.toLocaleString('it-IT') }}
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: 'ServiceBreakdownList',
  props: {
    items: { type: Array, default: () => [] },
    emptyLabel: { type: String, default: 'No data' }
  }
};
</script>

<style scoped>
.breakdown-table {
  background: transparent;
}
.breakdown-name {
  max-width: 220px;
  word-break: break-all;
}
</style>
